import ProductListingPage from "./ProductListingPage";

export const ProductListingPageWrapper = props => (
  <ProductListingPage {...props} />
);

export default require("../../containers/withTogglePoint").default(ProductListingPageWrapper, require.context("./__variants__/", true, /^\.\/([^/]+\/){2}ProductListingPageWrapper\.js$/))
